import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";
import { vehicleBrands } from "./vehicle-brands";
import { vehicleModels } from "./vehicle-models";
import { vehicleSubModels } from "./vehicle-sub-models";
import { vehicleGenerations } from "./vehicle-generations";
import { vehicleBodyTypes } from "./vehicle-body-types";
import { vehicleColors } from "./vehicle-colors";
import { vehicleYards } from "./vehicle-yards";

// ============================================================================
// vehicles — ข้อมูลรถแต่ละคัน (Vehicle Master)
// ============================================================================
export const fleetVehicles = sqliteTable("fleet_vehicles", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  yardId: text("yard_id").references(() => vehicleYards.id),
  vehicleCode: text("vehicle_code"),
  vehicleName: text("vehicle_name").notNull(),
  licensePlate: text("license_plate").notNull(),
  licenseProvince: text("license_province"),
  vin: text("vin"),
  engineNumber: text("engine_number"),
  brandId: text("brand_id").references(() => vehicleBrands.id),
  modelId: text("model_id").references(() => vehicleModels.id),
  subModelId: text("sub_model_id").references(() => vehicleSubModels.id),
  generationId: text("generation_id").references(() => vehicleGenerations.id),
  bodyTypeId: text("body_type_id").references(() => vehicleBodyTypes.id),
  colorId: text("color_id").references(() => vehicleColors.id),
  colorName: text("color_name"),
  manufacturingYear: integer("manufacturing_year"),
  registrationDate: text("registration_date"),
  transmission: text("transmission", {
    enum: ["auto", "manual", "cvt", "dct"],
  }),
  fuelType: text("fuel_type", {
    enum: ["gasoline", "diesel", "ev", "hybrid", "plugin_hybrid", "lpg", "cng"],
  }),
  seats: integer("seats"),
  doors: integer("doors"),
  mileage: real("mileage").default(0),
  purchaseDate: text("purchase_date"),
  purchasePrice: real("purchase_price"),
  currentValue: real("current_value"),
  status: text("status", {
    enum: ["active", "inactive", "maintenance", "sold", "scrapped"],
  })
    .notNull()
    .default("active"),
  ownershipType: text("ownership_type", {
    enum: ["owned", "leased", "financed"],
  }),
  // Cost center (#411) — soft FK to `accounting_cost_centers.id`. Nullable:
  // when set, overrides the branch / company default in the auto-fill chain
  // used by shared accounting modals + cost-center P&L reports. Soft FK keeps
  // fleet compilable even when the accounting module is not bundled.
  costCenterId: text("cost_center_id"),
  notes: text("notes"),
  imageUrl: text("image_url"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("fv_company_status_idx").on(table.companyId, table.status),
  companyBrandIdx: index("fv_company_brand_idx").on(table.companyId, table.brandId),
}));

export type FleetVehicle = typeof fleetVehicles.$inferSelect;
export type NewFleetVehicle = typeof fleetVehicles.$inferInsert;
